module.exports = __webpack_public_path__ + "img/alerta.653564cd.png";